function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Button, Grid, GridItem, TextButton, Typography } from 'seagull';
import BankSecurityRow from "../../../components/BankSecurityRow/BankSecurityRow";
import ManagePaymentMethods from "../../../components/ManagePaymentMethods/ManagePaymentMethods";
import { usePaymentMethodLearnMoreModal } from "../../../components/PaymentMethodLearnMoreModal/usePaymentMethodLearnMoreModal";
import { useStore } from "../../../contexts";
import { useRequestPM } from "../../../hooks/useRequestPaymentMethod";
import { relationshipModel } from "../../../models";
import StripeElementsProvider from "../../../providers/StripeElementsProvider";
import { selectors } from "../../../store/state-selectors";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./PaymentMethods.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PaymentMethods(props) {
  const {
    isVendor,
    agreement,
    onRefreshAgreement
  } = props;
  const isMemberUser = useStore(selectors.user.isMemberUser);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isMemberClient = !isVendor && isMemberUser;
  const openLearnMoreModal = usePaymentMethodLearnMoreModal();
  const requestPm = useRequestPM();
  const [isAddingAnotherPaymentMethod, setIsAddingAnotherPaymentMethod] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MinisiteTabHeader, {
      "data-testid": "payment-methods-page-header",
      text: /*#__PURE__*/_jsxs(_Fragment, {
        children: ["Payment Methods", /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          children: ['Manage payment methods for this agreement. ', /*#__PURE__*/_jsx(TextButton, {
            onClick: openLearnMoreModal,
            children: "Learn more"
          })]
        })]
      }),
      actions: /*#__PURE__*/_jsxs("div", {
        className: styles.actionButtonsContainer,
        children: [isVendor && /*#__PURE__*/_jsx(Button, {
          skin: 'primaryOutlineOpaque',
          "data-testid": 'request-payment-method-btn',
          onClick: () => requestPm(agreement.id),
          children: "Request payment method"
        }), /*#__PURE__*/_jsx(Button, {
          skin: "primary",
          "data-testid": "add-payment-method-btn",
          onClick: () => setIsAddingAnotherPaymentMethod(true),
          children: "Add payment method"
        })]
      })
    }), /*#__PURE__*/_jsxs(Grid, {
      children: [!relationshipModel.isTerminated(agreement) && /*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(StripeElementsProvider, {
          children: /*#__PURE__*/_jsx(ManagePaymentMethods, _objectSpread({
            isAddingAnotherPaymentMethod: isAddingAnotherPaymentMethod,
            setIsAddingAnotherPaymentMethod: setIsAddingAnotherPaymentMethod,
            isVendorCoveringFees: relationshipModel.actualIsVendorCoveringCCFee(agreement),
            vendorId: relationshipModel.vendor(agreement),
            customerId: relationshipModel.customer(agreement),
            showCreditCardFee: !relationshipModel.isVendorCoveringCCFee(agreement),
            isProposal: false,
            isPreview: false,
            isSample: relationshipModel.isSample(agreement),
            isMemberClient: isMemberClient,
            hideInviteMemberHint: isVendor,
            isInviteMemberDisabled: isAccountant || relationshipModel.isSample(agreement),
            relationshipId: relationshipModel.id(agreement),
            onPaymentMethodUpdated: () => onRefreshAgreement({
              silent: true
            }),
            hideExpandableAddPmButton: true
          }, props))
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(BankSecurityRow, {})
      })]
    })]
  });
}